import { render, staticRenderFns } from "./BreakdownPanel.vue?vue&type=template&id=99464dfe&scoped=true&"
import script from "./BreakdownPanel.vue?vue&type=script&lang=js&"
export * from "./BreakdownPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99464dfe",
  null
  
)

export default component.exports